import { Editor } from '@tiptap/core'
import { EditorState, PluginKey } from '@tiptap/pm/state'
import { npubEncode } from '@nostr/tools/nip19'
import { findInstalledSlashCommands, TInstalledSlashCommand } from '@/atoms/slash-commands'
import { slashCommandAppliesToEvent } from '@/lib/slash-command-definition'
import { getEditorContext } from './composerContext'
import { createSuggestionRender } from './slash-popup'
import SlashCommandList from './SlashCommandList'

type RendererProps = {
  editor: Editor
  items: { slashCommand: TInstalledSlashCommand }[]
  command: (payload: { slashCommand: TInstalledSlashCommand }) => void
}

const slashSuggestion = {
  char: '/',
  pluginKey: new PluginKey('slashCommandSuggestion'),
  startOfLine: true,

  // only trigger when "/" is the first thing in the textarea
  allow: ({ state, range }: { state: EditorState; range: { from: number } }) => {
    return state.doc.textBetween(0, range.from, '\n', ' ').trim() === ''
  },

  items: ({ editor, query }: { editor: Editor; query: string }) => {
    const context = getEditorContext(editor)
    // without composer context we can't know if the commands apply, so show nothing
    if (!context) return []

    return findInstalledSlashCommands(query, 20, (slashCommand) =>
      slashCommandAppliesToEvent(slashCommand, context)
    ).map((slashCommand) => ({ slashCommand }))
  },

  command: ({
    editor,
    range,
    props
  }: {
    editor: Editor
    range: { from: number; to: number }
    props: { slashCommand: TInstalledSlashCommand }
  }) => {
    const { slashCommand } = props

    editor
      .chain()
      .focus()
      .insertContentAt(range, [
        {
          type: 'slashCommand',
          attrs: {
            command: slashCommand.command,
            pubkey: slashCommand.pubkey,
            d: slashCommand.d,
            npub: npubEncode(slashCommand.pubkey)
          }
        },
        {
          type: 'text',
          text: ' '
        }
      ])
      .run()
  },

  render: createSuggestionRender<RendererProps>(SlashCommandList)
}

export default slashSuggestion
